exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".simple-currency-drowpdown-item {\n  display: flex;\n  align-items: center;\n  padding: 6px;\n}\n\n.simple-currency-drowpdown-item .csas-flags {\n  margin-right: 10px;\n}\n\n.simple-currency-drowpdown-item:hover {\n  background: #40a3d5;\n  cursor: pointer;\n}\n", ""]);

// exports
